import { useLocation } from 'react-router-dom';

function useRouteMatch(patterns: readonly string[]) {
  const { pathname } = useLocation();

  return patterns.find((p) => pathname.startsWith(p)) || '';
}

export default useRouteMatch;
